import React from 'react';  
import './index.css';
import { WingBlank } from 'antd-mobile'; 
 
 
class ReportScore extends React.Component{
  render(){
    return (
      <div  className="report-item">
        <p className="report-title">我的得分</p>
        <WingBlank>
        {
          this.props.score&&this.props.score!=0
          ?
          <p>{this.props.score}分</p>
          :
          <p></p>
        }
        </WingBlank>
      </div>
      )
  }
}
export default ReportScore;